var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompanies({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69831",
    "data-name": "Group 69831",
    transform: "translate(5036 -11161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15581",
    "data-name": "Group 15581",
    transform: "translate(-5060 11009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 152)",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69827",
    "data-name": "Group 69827",
    transform: "translate(-5023.001 11174.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12181",
    "data-name": "Group 12181",
    transform: "translate(0 -1.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "building",
    d: "M7.1,13.719H9.126a.648.648,0,0,0,.611-.677V10.782a.648.648,0,0,0-.611-.677H7.1a.648.648,0,0,0-.611.677V13.04a.648.648,0,0,0,.611.679Zm6.49,0h2.028a.648.648,0,0,0,.611-.677V10.782a.648.648,0,0,0-.611-.677H13.588a.648.648,0,0,0-.611.677V13.04a.648.648,0,0,0,.611.679ZM9.736,18.466V16.2a.648.648,0,0,0-.611-.677H7.1a.648.648,0,0,0-.611.677v2.263a.648.648,0,0,0,.611.677H9.126A.648.648,0,0,0,9.736,18.466Zm3.854.677h2.028a.648.648,0,0,0,.611-.677V16.2a.648.648,0,0,0-.611-.677H13.59a.648.648,0,0,0-.611.677v2.263a.648.648,0,0,0,.61.673Zm9.131,7v2.033H0V26.14a.648.648,0,0,1,.611-.677H1.6V6.354A1.29,1.29,0,0,1,2.81,5H19.9a1.2,1.2,0,0,1,.874.405,1.379,1.379,0,0,1,.348.949V25.463h.987a.648.648,0,0,1,.611.677Zm-18.69-.733h5.7V21.623a.648.648,0,0,1,.611-.677h2.028a.648.648,0,0,1,.611.677v3.783h5.7V7.766L4.057,7.71Z",
    transform: "translate(0 -5)",
    fill: "#767493"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanies);
export default __webpack_public_path__ + "static/media/icon_companies.00a56b41e4ee20a99ee3669197a7d858.svg";
export { ForwardRef as ReactComponent };